import React from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../../interfaces';
import * as Transfer from '../../../modules/dialogs/transfer';
import TxDialogSend from './txDialogSend';
import TxDialogSendCheck from './txDialogSendCheck';
import TxDialogSendFinal from './txDialogSendFinal';
import TxDialogReq from './txDialogReq';
import TxDialogReqCheck from './txDialogReqCheck';
import TxDialogReqFinal from './txDialogReqFinal';
import TxDialogActivitiesOpen from './txDialogActivitiesOpen';
import TransferActivitiesClosedDialog from './txDialogActivitiesClosed';
import './transfer.scss';

interface StateProps extends Transfer.State {
}

type Props = StateProps;

const TxDialog: React.FC<Props> = (props) => {
  let dialog = <TxDialogSend />;
  switch (props.screen) {
    case Transfer.TransferDialogs.ACTIVITIES:
      dialog = <TxDialogActivitiesOpen />;
      break;
    case Transfer.TransferDialogs.ACTIVITIES_CLOSED:
        dialog = <TransferActivitiesClosedDialog />;
        break;
    case Transfer.TransferDialogs.REQUEST:
      dialog = <TxDialogReq />;
      break;
    case Transfer.TransferDialogs.REQUEST_VALIDATE:
      dialog = <TxDialogReqCheck />;
      break;
    case Transfer.TransferDialogs.REQUEST_CONFIRM:
      dialog = <TxDialogReqFinal />;
      break;
    case Transfer.TransferDialogs.SEND_VALIDATE:
      dialog = <TxDialogSendCheck />;
      break;
    case Transfer.TransferDialogs.SEND_CONFIRM:
      dialog = <TxDialogSendFinal />;
      break;
  }
  return dialog;
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  ...state.dialogState.transferState
});

export default connect(mapStateToProps)(TxDialog);
